import { all } from 'redux-saga/effects';
import taskSagas from './tasks';
import undatedtaskSagas from './undatedtasks';
import pendingjobsSagas from './pendingjobs';
import actionrequiredSagas from './actionRequired';
import closedjobsSagas from './closedJobs';

import materialSagas from './materials';
import labourSagas from './labours';
import defectSagas from './defects';
import taskHistorySagas from './taskHistory';
import productHistorySagas from './productHistory';
import warehouseProductSagas from './warehouseProduct';
import testSagas from './test';

export default function* rootSaga() {
  yield all([
    ...taskSagas,
    ...undatedtaskSagas,
    ...pendingjobsSagas,
    ...actionrequiredSagas,
    ...closedjobsSagas,
    ...materialSagas,
    ...labourSagas,
    ...defectSagas,
    ...taskHistorySagas,
    ...productHistorySagas,
    ...warehouseProductSagas,
    ...testSagas
  ]);
}
